import { buildings } from "../data/buildings";
import BuildingCard from "../components/common/BuildingCard";
import EnquiryForm from "../components/common/EnquiryForm";

export default function Locations() {
  return (
    <main className="pt-16 md:pt-20">
      <section
        className="relative w-full h-64 md:h-80"
        style={{ backgroundImage: "url('/static/images/hero-locations.webp')", backgroundSize: "cover", backgroundPosition: "center" }}
      >
        <div className="absolute inset-0 bg-black/40" />
      </section>

      <section className="w-full px-4 sm:px-8 lg:px-16 py-12 bg-[#f5f4f0]">
        <h1 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-4">Our locations</h1>
        <p className="text-gray-600 leading-relaxed max-w-2xl text-base mb-6">
          Our locations are conveniently spread across London, offering a wide range of workspaces from compact studios to expansive units. With sizes starting at just 65 sq ft and extending up to 10,000 sq ft, there's a space to suit every need — whether you're an independent creative, a small team, or a well-established business looking for room to grow.
        </p>
        <a href="#locations-grid" className="inline-flex items-center gap-2 text-sm font-semibold text-[#8a7d5a] tracking-widest uppercase hover:gap-4 transition-all duration-200">
          VIEW OUR SPACES MAP <span>→</span>
        </a>
      </section>

      <section id="locations-grid" className="w-full bg-white">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {buildings.map((building) => (
            <BuildingCard key={building.slug} building={building} />
          ))}
        </div>
      </section>

      <EnquiryForm pageUri="https://artistic-spaces.co.uk/our-locations" pageName="Our Locations" />
    </main>
  );
}